import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TaskProgressionNotification } from '../models/ws/notifications/task-progression-notification';

@Injectable({
    providedIn: 'root',
})
export class TaskProgressionService {
    constructor() {}

    private onTaskProgressionChanged = new Subject<TaskProgressionNotification>();

    /**
     * Emet un événement lorsque la progression d'une tache change.
     */
    public changeStatesSet(taskProgressionNotification: TaskProgressionNotification): void {
        this.onTaskProgressionChanged.next(taskProgressionNotification);
    }

    /**
     * Recupère la progression d'une tache
     */
    public get onTaskProgressionChanged$(): Observable<TaskProgressionNotification> {
        return this.onTaskProgressionChanged.asObservable();
    }
}
